import { ReactNode } from 'react';

type Props = {
    dateAdded?: ReactNode;
    email: ReactNode;
    item: ReactNode;
    lastAlert?: ReactNode;
};

/**
 * Row geometry for the Similar Item Alerts table, used by both the column header and each alert row.
 *
 * It deliberately mirrors `TableRow`'s proportions — a 3/4 + 1/4 split, with the right quarter
 * divided into the same three checkbox columns and the same `mx-auto`/`-12px` label offset. The
 * section header above this table *is* a `TableRow`, so anything else leaves the EMAIL checkboxes
 * visibly off-axis from the section's. Keep the two in sync if `TableRow` ever changes.
 */
export const SimilarItemAlertsTableRow = ({ dateAdded, email, item, lastAlert }: Props) => (
    <div className="flex gap-md border-b border-border-secondary p-sm">
        <div className="grid w-3/4 items-center gap-sm tabletMin:grid-cols-[7fr_6fr_2fr] xsMax:w-3/5">
            {item}
            <div className="hidden tabletMin:block">{lastAlert}</div>
            <div className="hidden tabletMin:block">{dateAdded}</div>
        </div>
        <div className="flex w-1/4 items-center xsMax:w-2/5">
            {/* Spacers for the SMS and BROWSER columns this section doesn't use, so EMAIL lands in
                the same third as the section header's. */}
            <div className="w-1/3 xsMax:w-1/2" />
            <div className="w-1/3 xsMax:w-1/2" />
            <div className="w-1/3 xsMax:w-1/2">
                <div className="mx-auto w-fit [&>label]:mr-[-12px]">{email}</div>
            </div>
        </div>
    </div>
);
